import React, { ChangeEventHandler, useState } from "react";
import { useTranslation } from "react-i18next";
import searchIcon from "../../../assets/search.svg";
import Skeleton from "react-loading-skeleton";
import chevron from "../../../assets/chevron.svg";
import SortByDropdown from "../dropdown/SortByDropdown";

type NewsFilterBarProps = {
  textQuery: string;
  setTextQuery: ChangeEventHandler<HTMLInputElement>;
  orderBy: string;
  setOrderBy: (newOrderBy: string) => void;
};

const NewsFilterBar: React.FC<NewsFilterBarProps> = ({
  textQuery,
  setTextQuery,
  orderBy,
  setOrderBy,
}) => {
  const { ready, t } = useTranslation();
  const [showSortByDropdown, setShowSortByDropdown] = useState<boolean>(false);

  const toggleSortByDropdown = () => {
    setShowSortByDropdown(!showSortByDropdown);
  };

  const searchPlaceholder = () => {
    return (
      <img className="filter-search-icon" src={searchIcon} alt="search-icon" />
    );
  };

  const getSortByString = () => {
    if (orderBy === "desc") {
      return t("catalogue-filter.most-recent");
    } else if (orderBy === "asc") {
      return t("catalogue-filter.oldest");
    }
    return t("catalogue-filter.sort");
  };

  return (
    <div className="filter-container mt-2">
      <div className="searchBar-container">
        <div className="searchBar-input-searchIcon">
          <input
            placeholder={ready ? `${t("catalogue-filter.search")}` : ``}
            className="form-control"
            type="text"
            value={textQuery}
            onChange={setTextQuery}
          />
          {searchPlaceholder()}
        </div>
      </div>
      <div onClick={toggleSortByDropdown} className="sortby-dropdown">
        <div className="form-control flex-space-between">
          <div>{ready ? getSortByString() : <Skeleton width={80} />}</div>
          <div>
            {showSortByDropdown ? (
              <img
                className="filter-chevron up-chevron"
                src={chevron}
                alt="Chevron icon"
              />
            ) : (
              <img
                className="filter-chevron "
                src={chevron}
                alt="Chevron icon"
              />
            )}
          </div>
        </div>
        {showSortByDropdown ? (
          <SortByDropdown
            setOrderBy={setOrderBy}
            toggleSortByDropdown={toggleSortByDropdown}
          />
        ) : null}
      </div>
    </div>
  );
};

export default NewsFilterBar;
